<template>
  <div class="welcome-wrap">
    <!-- 左上角快捷卡片：工商储能（PCS 实时数据概览），点击进入实时数据页 -->
    <div class="quick-entry">
      <div class="pcs-card" @click="goRealtime">
        <div class="card-head">
          <span class="card-title">工商储能</span>
        </div>
        <div class="card-body">
          <div class="card-item">
            <div class="item-label">交流历史充电量</div>
            <div class="item-value">
              {{ pcs.chg }}<span class="unit">kWh</span>
            </div>
          </div>
          <div class="card-item">
            <div class="item-label">交流历史放电量</div>
            <div class="item-value">
              {{ pcs.dsg }}<span class="unit">kWh</span>
            </div>
          </div>
          <div class="card-item">
            <div class="item-label">交流输出总视在功率</div>
            <div class="item-value">
              {{ pcs.apparentPower }}<span class="unit">kVA</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title">
      <h1 class="animated bounceInDown">欢迎进入{{ companyTitle }}</h1>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

// 工商储能卡片对应的设备（PCS 实时数据）
const PCS_DEVICE_SN = "KPT-31500001";

// 字段名归一化：小写 + 去下划线，兼容后端 Java 属性名大小写差异
// （ApparentPower / apparentPower、Read_6 / read_6 等）
const normKey = k =>
  String(k)
    .toLowerCase()
    .replace(/_/g, "");
const pick = (data, key) => {
  if (!data) return undefined;
  const nk = normKey(key);
  for (const k of Object.keys(data)) {
    if (normKey(k) === nk) return data[k];
  }
  return undefined;
};
const fmt = v => (v === undefined || v === null || v === "" ? "-" : v);

export default {
  name: "Welcome",
  data() {
    return {
      companyTitle: "",
      // 卡片展示的三个 PCS 值
      pcs: {
        chg: "-", // 交流历史充电量(kWh)  —— Read_6
        dsg: "-", // 交流历史放电量(kWh)  —— Read_8
        apparentPower: "-" // 交流输出总视在功率(kVA) —— ApparentPower
      },
      pcsTimer: null
    };
  },
  beforeMount() {
    // this.$store.dispatch("form/handle", {
    //   url: "/user/login/getCurInfo",
    //   callback: resp => {
    //     let companyId = resp.companyId;
    //     this.$store.dispatch("form/handle", {
    //       url: "/battery/offline/query",
    //       data: { companyId: companyId },
    //       method: "get",
    //       callback: resp => {
    //         if (resp.title) {
    //           this.companyTitle = resp.title;
    //         }
    //       }
    //     });
    //   }
    // });
  },
  mounted() {
    this.loadPcs();
    // 每 5 秒刷新一次卡片数据
    this.pcsTimer = setInterval(() => this.loadPcs(), 5000);
  },
  beforeDestroy() {
    if (this.pcsTimer) {
      clearInterval(this.pcsTimer);
      this.pcsTimer = null;
    }
  },
  methods: {
    // 读取 PCS 实时数据：先下发取数请求触发设备上报，再读取已落库结果
    async loadPcs() {
      try {
        await request.post2("/battery/realtime/query", {
          deviceType: "PCS",
          deviceSn: PCS_DEVICE_SN,
          mi: 5
        });
      } catch (e) {
        // 取数请求失败不阻塞读取
      }
      try {
        const resp = await request.get2("/battery/realtime/data", {
          deviceType: "PCS",
          deviceSn: PCS_DEVICE_SN
        });
        const d = resp && resp.data ? resp.data : {};
        this.pcs = {
          chg: fmt(pick(d, "Read_6")),
          dsg: fmt(pick(d, "Read_8")),
          apparentPower: fmt(pick(d, "ApparentPower"))
        };
      } catch (e) {
        // 静默失败，保留上次展示值
      }
    },
    // 卡片点击跳转：进入该设备的实时数据页
    goRealtime() {
      this.$router.push({
        path: "/realtimeQuery",
        query: {
          deviceSn: PCS_DEVICE_SN,
          deviceType: "BMS"
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.welcome-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

// 左上角快捷卡片（相对 el-main 定位；el-main 左上角 = content 去掉左侧菜单宽度后的左上角）
.quick-entry {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
}

.pcs-card {
  width: 320px;
  padding: 18px 22px;
  border-radius: 10px;
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  color: #fff;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 6px 18px rgba(64, 158, 255, 0.35);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 24px rgba(64, 158, 255, 0.45);
  }
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;

  .card-title {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 1px;
  }
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-item {
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  .item-label {
    font-size: 13px;
    opacity: 0.9;
  }

  .item-value {
    font-size: 20px;
    font-weight: 600;

    .unit {
      margin-left: 4px;
      font-size: 12px;
      font-weight: 400;
      opacity: 0.85;
    }
  }
}

.title {
  width: 75%;
  height: 50%;
  margin-top: 15%;
  margin-left: 15%;

  h1 {
    font-size: 60px;
    font-weight: 500;
    line-height: 80px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue